// Parâmetros globais do sistema — persistidos em localStorage.
// Adicione novos parâmetros em DEFAULTS para que tenham valor padrão garantido.

const DEFAULTS = {
  sprints_historico: 4,  // quantidade de sprints exibidas na tela Histórico
};

export function getParam(chave) {
  try {
    const saved = localStorage.getItem(`param_${chave}`);
    return saved !== null ? JSON.parse(saved) : DEFAULTS[chave] ?? null;
  } catch {
    return DEFAULTS[chave] ?? null;
  }
}

export function setParam(chave, valor) {
  localStorage.setItem(`param_${chave}`, JSON.stringify(valor));
}

export function getDefaults() {
  return { ...DEFAULTS };
}

export function resetParams() {
  Object.keys(DEFAULTS).forEach(k => localStorage.removeItem(`param_${k}`));
}
